import { FC } from 'react'

export const IconOutOfGaugeFront: FC<{ zoom?: number; size?: number }> = ({ zoom, size }) => {
  return (
    <svg
      width={size ?? '32'}
      height={size ?? '32'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: `scale(${(zoom ?? 100) / 100})` }}
    >
      <path
        d='M14.2821 14.9947L5.30639 15.0058C5.1407 15.0061 5.00622 14.8719 5.00602 14.7062L4.9947 5.73049C4.99437 5.46322 5.31734 5.32896 5.50657 5.51772L8.11893 8.12354C8.23623 8.24055 8.42618 8.24031 8.54319 8.12301L13.1132 3.54158C13.2302 3.42428 13.4201 3.42404 13.5374 3.54105L16.4502 6.44651C16.5675 6.56352 16.5677 6.75347 16.4507 6.87077L11.8807 11.4522C11.7637 11.5695 11.764 11.7594 11.8813 11.8765L14.4936 14.4823C14.6828 14.671 14.5494 14.9943 14.2821 14.9947Z'
        fill='#212B36'
      />
    </svg>
  )
}

export default IconOutOfGaugeFront
